export enum EavParent {
    EXAM_CENTER = "EXAM_CENTER",
}

export enum EavClassName {
    EXAM_CENTER_PARAM = "EXAM_CENTER_PARAM",
}

export enum EavAttributeName {
    USE_EQUESTIONNAIRE = "USE_EQUESTIONNAIRE",
}
